export default __webpack_public_path__ + "static/media/icon-shopping.886b70ea.png";